import { useRef } from 'react';
import { Paper, Modal, Button, Group, Title } from '@mantine/core';
import { IconTrash, IconX, IconCheck } from '@tabler/icons-react';

type ModalVariant = 'delete' | 'update' | 'create';

interface ModalConfig {
  title: string;
  message: (params: Record<string, string>) => string;
  confirmMessage: string;
  icon: typeof IconTrash | typeof IconCheck;
  color: string;
}

const MODAL_VARIANTS: Record<ModalVariant, ModalConfig> = {
  delete: {
    title: 'מחיקת פריט',
    message: (
      params
    ) => `האם אתה בטוח שברצונך למחוק את הפריט ${params.itemName}?
	פעולה זו בלתי ניתנת לביטול!`,
    confirmMessage: `מחק`,
    icon: IconTrash,
    color: 'red',
  },
  update: {
    title: 'עדכון פריט',
    message: (params) =>
      `האם אתה בטוח שברצונך לעדכן את הפריט ${params.itemName}?`,
    confirmMessage: `מחק`,
    icon: IconCheck,
    color: 'blue',
  },
  create: {
    title: 'יצירת פריט',
    message: (params) =>
      `האם אתה בטוח שברצונך ליצור את הפריט ${params.itemName}?`,
    confirmMessage: `מחק`,
    icon: IconCheck,
    color: 'green',
  },
};
interface ConfirmModalProps {
  opened: boolean;
  onClose: () => void;
  onConfirm: () => void;
  variant?: ModalVariant;
  params?: Record<string, string>;
}

export default function ConfirmModal({
  opened,
  onClose,
  onConfirm,
  variant = 'delete',
  params = {},
}: ConfirmModalProps) {
  const config = MODAL_VARIANTS[variant];
  const Icon = config.icon;

  // Ensure a rerender does not change the item name when the modal closes if it is deleted.
  const nameRef = useRef<string>('');
  const getMessage = () => {
    if (opened && params.itemName) {
      nameRef.current = params.itemName;
    }
    return config.message({ itemName: nameRef.current });
  };

  return (
    <Modal opened={opened} withCloseButton={false} onClose={onClose} centered>
      <Paper bg="red.1" p="sm" withBorder radius="md">
        <p>{getMessage()}</p>
      </Paper>
      <Group justify="flex-end" mt="md">
        <Button
          variant="subtle"
          onClick={onClose}
          leftSection={<IconX size={16} />}
        >
          ביטול
        </Button>
        <Button
          variant="filled"
          color={config.color}
          onClick={() => {
            onConfirm();
            onClose();
          }}
          leftSection={<Icon size={16} />}
        >
          {config.confirmMessage}
        </Button>
      </Group>
    </Modal>
  );
}
